import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import { AuthGuard } from 'app/auth/auth-guard.service';
import { ListCompanyDetailsPageComponent } from 'app/lists/list-company-details-page/list-company-details-page.component';
import { ListCompanyPageComponent } from 'app/lists/list-company-page/list-company-page.component';
import { ListCompanyUnsubscriptionComponent } from 'app/lists/list-company-unsubscription/list-company-unsubscription.component';
import { ListProjectDetailsPageComponent } from 'app/lists/list-project-details-page/list-project-details-page.component';
import { ListProjectPageComponent } from 'app/lists/list-project-page/list-project-page.component';
import { ListProjectUnsubscriptionComponent } from 'app/lists/list-project-unsubscription/list-project-unsubscription.component';
import { ReleaseUpdateGuard } from 'app/shared/service/release-update-guard.service';

import { AddListComponent } from './add-list/add-list.component';

const routes: Route[] = [
  {
    path: 'companies/:companyId',
    component: ListCompanyPageComponent,
    canActivate: [AuthGuard, ReleaseUpdateGuard],
    children: [
      {
        path: 'new',
        component: AddListComponent,
      },
    ],
  },
  {
    path: 'companies/:companyId/:listId',
    component: ListCompanyDetailsPageComponent,
    canActivate: [AuthGuard, ReleaseUpdateGuard],
  },
  {
    path: 'companies/:companyId/:listId/properties/:propertyId/unsubscribe',
    component: ListCompanyUnsubscriptionComponent,
    canActivate: [AuthGuard, ReleaseUpdateGuard],
  },
  {
    path: 'projects/:projectId',
    component: ListProjectPageComponent,
    canActivate: [AuthGuard, ReleaseUpdateGuard],
    children: [
      {
        path: 'new',
        component: AddListComponent,
      },
    ],
  },
  {
    path: 'projects/:projectId/:listId',
    component: ListProjectDetailsPageComponent,
    canActivate: [AuthGuard, ReleaseUpdateGuard],
  },
  {
    path: 'projects/:projectId/:listId/properties/:propertyId/unsubscribe',
    component: ListProjectUnsubscriptionComponent,
    canActivate: [AuthGuard, ReleaseUpdateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ListsRoutingModule {}
